<template>
  <div id="platformData">
    <el-tabs v-model="tabAction">
      <el-tab-pane label="核心数据" name="coreData">
        <coreData v-if="tabAction == 'coreData'" ref="coreData"></coreData>
      </el-tab-pane>
      <el-tab-pane label="运力数据" name="capacityData">
        <capacityData v-if="tabAction == 'capacityData'" ref="capacityData"></capacityData>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import coreData from "./coreData.vue";
import capacityData from "./capacityData.vue";
export default {
  name: "platformData",
  components: {
    coreData,
    capacityData,
  },
  data() {
    return {
      tabAction: "coreData",
    };
  },

  methods: {},
};
</script>